import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Facebook = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M20.9996 12.0331C20.9996 7.0443 16.9702 3 11.9998 3 7.0294 3 3 7.0443 3 12.0331c0 4.2361 2.9059 7.7908 6.8258 8.7671v-6.0066H7.9701v-2.7605h1.8557v-1.1895c0-3.0745 1.3864-4.4996 4.3937-4.4996.5703 0 1.5541.1124 1.9566.2244v2.5022c-.2124-.0224-.5814-.0336-1.0397-.0336-1.4756 0-2.0458.5611-2.0458 2.0198v.9763h2.9397l-.5051 2.7605h-2.4346V21C17.5469 20.4598 21 16.6515 21 12.0331h-.0004z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M20.9996 12.0331C20.9996 7.0443 16.9702 3 11.9998 3 7.0294 3 3 7.0443 3 12.0331c0 4.2361 2.9059 7.7908 6.8258 8.7671v-6.0066H7.9701v-2.7605h1.8557v-1.1895c0-3.0745 1.3864-4.4996 4.3937-4.4996.5703 0 1.5541.1124 1.9566.2244v2.5022c-.2124-.0224-.5814-.0336-1.0397-.0336-1.4756 0-2.0458.5611-2.0458 2.0198v.9763h2.9397l-.5051 2.7605h-2.4346V21C17.5469 20.4598 21 16.6515 21 12.0331h-.0004z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Facebook.displayName = "FacebookIcon";

export { Facebook, Facebook as default };
